function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8378 0H2.16216C0.969595 0 0 0.969595 0 2.16216V28.1081C0 29.3007 0.969595 30.2703 2.16216 30.2703H17.8378C19.0304 30.2703 20 29.3007 20 28.1081V2.16216C20 0.969595 19.0304 0 17.8378 0ZM17.5676 27.8378H2.43243V2.43243H17.5676V27.8378ZM8.64865 24.3919C8.64865 24.7503 8.79102 25.094 9.04445 25.3474C9.29788 25.6009 9.6416 25.7432 10 25.7432C10.3584 25.7432 10.7021 25.6009 10.9556 25.3474C11.209 25.094 11.3514 24.7503 11.3514 24.3919C11.3514 24.0335 11.209 23.6898 10.9556 23.4363C10.7021 23.1829 10.3584 23.0405 10 23.0405C9.6416 23.0405 9.29788 23.1829 9.04445 23.4363C8.79102 23.6898 8.64865 24.0335 8.64865 24.3919Z",
  fill: "currentColor"
});

var SvgIcPhone = function SvgIcPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 31,
    viewBox: "0 0 20 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_phone.196c973f.svg";
export { ForwardRef as ReactComponent };